import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import './page-404.css'

const Page404 = () => {
    const location = useLocation()
    const msg =
        location && location.state && location.state.msg
            ? location.state.msg
            : 'Não foi possível encontrar a página que você procura.'
    return (
        <div className="Page404--container">
            <span className="Page404--main-text">Ooops!</span>
            <span className="Page404--secondary-text">{msg}</span>
            <span className="Page404--secondary-text">
                Que tal voltar para a nossa{' '}
                <Link id="Page404--link-home" to={{ pathname: '/applications/1' }}>
                    Home
                </Link>
                ?
            </span>
        </div>
    )
}

Page404.propTypes = {
    location: PropTypes.object,
}
export default Page404
